"use client";

import { Translate } from "@/components/Translate";
import { Prose } from "@/components/ui/Prose";
import React from "react";
import styles from "./error.module.css";
import { Button } from "@/components/ui/Button";

const ErrorPage = ({
	reset,
	error,
}: {
	reset: () => void;
	error: Error & {
		digest: string;
	};
}) => {
	return (
		<div className={styles.errorPage}>
			<Prose>
				<h1>
					<Translate>Something went wrong delivering this page.</Translate>
				</h1>

				<p>
					<Translate>A report has been sent to the site administrator.</Translate>
				</p>

				{error?.digest && (
					<pre style={{ marginBottom: "1rem" }}>
						<code>Digest: {error.digest}</code>
					</pre>
				)}

				<Button onClick={reset}>
					<Translate>Refresh and try again</Translate>
				</Button>
			</Prose>
		</div>
	);
};

export default ErrorPage;
